import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import "./acc-login.m.css";

const AccLoginBtn = ({ signinHandler, onAccountHandler }) => {
  const isUserLogin = useSelector((state) => get(state, ["isLogin"], false));

  return (
    <button
      styleName="btn btn-login"
      onClick={isUserLogin ? onAccountHandler : signinHandler}
    >
      {isUserLogin ? "ಖಾತೆ" : "ಲಾಗಿನ್"}
    </button>
  );
};

export default AccLoginBtn;
